import { Divider } from "@chakra-ui/react";
import React from "react";

export const BlockDivider = () => {
  return (
    <Divider orientation={"vertical"} height={"50px"} borderRightWidth={1} />
  );
};
